module.exports = __webpack_public_path__ + "static/media/browser.a7bac7db.svg";